import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const ScreenLoader = () => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                bgcolor: 'rgba(255, 255, 255, 0.2)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1300,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}
        >
            <CircularProgress size={60} thickness={4} style={{ color: '#257076' }} />
        </Box>
    );
};

export default ScreenLoader;
